module.exports = __webpack_public_path__ + "static/media/2021_affiche_izheal.5e1de158.png";